import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Scrollbars } from 'react-custom-scrollbars';
import styles from './styles.scss';

const CustomScroll = props => (
  <Scrollbars
    universal
    renderThumbVertical={thumbProps => <div {...thumbProps} className={cn(styles.thumbVertical, 'thumb-vertical')} />}
    renderView={thumbProps => <div {...thumbProps} className={cn(styles.view, 'view')} />}
    {...props}
  >
    {props.children}
  </Scrollbars>
);

CustomScroll.propTypes = {
  style: PropTypes.objectOf(PropTypes.any),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

CustomScroll.defaultProps = {
  style: {},
};

export default CustomScroll;
